import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagFilter = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--filter', className].filter(Boolean).join(' ')} />
);
